<template>
  <div>
    <div class="page-header">
      <h1 class="page-title">Agents</h1>
      <a href="#" class="btn btn-primary" v-on:click.prevent="sendToCreateView"
        >Create Agent</a
      >
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="loading-overlay" v-if="loading"></div>
          <table class="table carpenter">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email Address</th>
                <th>Telephone</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-bind:key="index" v-for="(agent, index) in agents">
                <td v-text="agent.name"></td>
                <td v-text="agent.email"></td>
                <td v-text="agent.telephone"></td>
                <td>
                  <router-link
                    :to="'/agents/' + agent.identifier"
                    class="btn btn-primary btn-sm with-icon"
                    >Edit</router-link
                  >
                  <a
                    class="btn btn-danger btn-sm with-icon"
                    v-if="agent.active"
                    href=""
                    v-on:click.prevent="deactivate(agent)"
                    >Deactivate</a
                  >
                  <a
                    class="btn btn-success btn-sm with-icon"
                    v-else
                    href="#"
                    v-on:click.prevent="activate(agent)"
                    >Activate</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div class="pagination">
            <div class="btn-group" role="group">
              <button
                class="btn btn-primary btn-sm with-icon"
                type="button"
                :disabled="!prevPageUrl"
                v-on:click.prevent="previousPage"
              >
                <i class="material-icons">arrow_back</i>
                Back
              </button>
              <button
                class="btn btn-success btn-sm with-icon"
                type="button"
                :disabled="!nextPageUrl"
                v-on:click.prevent="nextPage"
              >
                <i class="material-icons">arrow_forward</i>
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      agents: [],
      nextPageUrl: null,
      prevPageUrl: null,
      currentPage: 1,
      loading: true
    };
  },

  mounted() {
    this.findAgents('/agents');
  },

  methods: {
    activate(agent) {
      window.Ajax.patch(`/agents/${agent.identifier}/activate`)
        .then(response => {
          window.toastify.success(
            'Activated',
            'The agent was activated successfully!'
          );
          agent.active = 1;
        })
        .catch(err => {});
    },

    deactivate(agent) {
      window.Ajax.patch(`/agents/${agent.identifier}/deactivate`)
        .then(response => {
          window.toastify.success(
            'Deactivated',
            'The agent was deactivated successfully!'
          );
          agent.active = 0;
        })
        .catch(err => {});
    },

    previousPage() {
      if (this.prevPageUrl) {
        let number = this.currentPage - 1;
        this.findAgents(`/agents?page=${number}`);
      }
    },

    nextPage() {
      if (this.nextPageUrl) {
        let number = this.currentPage + 1;
        this.findAgents(`/agents?page=${number}`);
      }
    },

    findAgents(url) {
      this.loading = true;

      window.Ajax.get(url)
        .then(response => {
          this.loading = false;
          this.agents = response.data.data;
          this.nextPageUrl = response.data.next_page_url;
          this.prevPageUrl = response.data.prev_page_url;
          this.currentPage = response.data.current_page;
        })
        .catch(err => {});
    },

    sendToCreateView() {
      this.route('/agents/create');
    }
  }
};
</script>
